import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: { marginBottom: 40 },
  title: theme => ({
    fontSize: 24,
    lineHeight: 30,
    marginBottom: 16,
    color: theme.colors.headerColor,
    ...Fonts.type.bold,
  }),
  description: theme => ({
    marginBottom: 20,
    fontSize: 16,
    letterSpacing: 0,
    color: theme.colors.textColorSix,
    fontFamily: Fonts.type.VFFont,
    lineHeight: 18,
  }),
  actionCard: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 5,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    height: 56,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColorThree,
  }),
  leftIcon: { marginBottom: 3 },
  actionTitle: theme => ({
    flexGrow: 1,
    marginStart: 17.1,
    fontSize: 18.8,
    lineHeight: 25,
    color: theme.colors.headerColor,
  }),
});
